import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const Deposit = ({
  size,
  type,
  theme,
  className,
  dataTestId = "deposit-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M6.287 8.48a.86.86 0 1 0 0-1.72.86.86 0 0 0 0 1.72Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.941 7.62a3.345 3.345 0 1 1 6.69 0 3.345 3.345 0 0 1-6.69 0Zm3.345-2.01a2.011 2.011 0 1 0 0 4.022 2.011 2.011 0 0 0 0-4.023Z"
    />
    <path d="M12.21 10.823a.667.667 0 0 1-.667-.667v-.749a.667.667 0 1 1 1.333 0v.75a.667.667 0 0 1-.666.666ZM11.543 5.833a.667.667 0 1 0 1.333 0v-.749a.667.667 0 0 0-1.333 0v.75Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.456 4.125a2 2 0 0 1 2-2h11.088a2 2 0 0 1 2 2v6.99a2 2 0 0 1-2 2h-.668v.46a.667.667 0 0 1-1.333 0v-.46H4.456v.46a.667.667 0 1 1-1.334 0v-.46h-.666a2 2 0 0 1-2-2v-6.99Zm2-.667a.667.667 0 0 0-.667.667v6.99c0 .368.299.666.667.666h11.088a.667.667 0 0 0 .666-.666v-6.99a.667.667 0 0 0-.666-.667H2.456Z"
    />
  </SVGIcon>
);
